module.exports = __webpack_public_path__ + "img/Löschstaffel.fb0993f9.svg";